<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="订单查询"
                left-arrow
                @click-left="onClickLeft"
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
            <template #right>
                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>
            </template>
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.5rem">
            <!--表单 start-->
            <van-form @submit="onSubmit">
                <!--开始日期 start-->
                <van-field
                        readonly
                        clickable
                        name="startDate"
                        :value="startDate"
                        label="开始日期"
                        placeholder="点击选择开始日期"
                        @click="showPickerStart = true"
                />
                <van-popup v-model="showPickerStart" round position="bottom">
                    <!--日期选择器 start-->
                    <van-datetime-picker
                            v-model="startDatePicker"
                            type="date"
                            title="选择开始日期"
                            @confirm="onConfirmStart"
                            @cancel="showPickerStart = false"
                    />
                    <!--日期选择器 end-->
                </van-popup>
                <!--开始日期 end-->
                <!--结束日期 start-->
                <van-field
                        readonly
                        clickable
                        name="endDate"
                        :value="endDate"
                        label="结束日期"
                        placeholder="点击选择结束日期"
                        @click="showPickerEnd = true"
                />
                <van-popup v-model="showPickerEnd" round position="bottom">
                    <!--日期选择器 start-->
                    <van-datetime-picker
                            v-model="endDatePicker"
                            type="date"
                            title="选择结束日期"
                            @confirm="onConfirmEnd"
                            @cancel="showPickerEnd = false"
                    />
                    <!--日期选择器 end-->
                </van-popup>
                <!--结束日期 end-->
                <van-field name="radio" label="交易类型">
                    <template #input>
                        <van-radio-group v-model="radio" direction="horizontal">
                            <van-row gutter="20">
                                <van-col span="12">
                                    <van-radio name="1">所有支付</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="2">微信支付</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="3">支付宝支付</van-radio>
                                </van-col>
                            </van-row>
                        </van-radio-group>
                    </template>
                </van-field>
                <!--按钮 start-->
                <div style="margin: 16px;">
                    <van-button round block type="info"
                                native-type="submit" size="small">
                        查询
                    </van-button>
                </div>
                <!--按钮 end-->
            </van-form>
            <!--表单 end-->
        </div>
        <!--内容 end-->
    </div>
</template>

<script>
    export default {
        name: "TransactionSearch", //订单查询
        data() {
            return {
                startDate: '', // 开始日期 默认显示数据
                showPickerStart: false, // 开始日期选择器 是否弹出
                startDatePicker: new Date(), // 开始日期选择器 选项 默认为当前日期
                endDate: '', // 结束日期 默认显示数据
                showPickerEnd: false, // 结束日期选择器 是否弹出
                endDatePicker: new Date(), // 结束日期选择器 选项 默认为当前日期
                radio: '1',
            };
        },
        created() {
            // 初始化开始日期 显示数据
            this.startDate = this.formatDate(new Date());
            // 初始化结束日期 显示数据
            this.endDate = this.formatDate(new Date());
        },
        methods: {
            // 返回上一级
            onClickLeft() {
                // 返回交易流水
                this.$router.push('/TransactionFlow');
            },
            // 右侧icon跳转至商户首页
            onClickRight() {
                // 返回商户首页
                this.$router.push('/MerchantHomepage');
            },
            // 小于10的日期补零
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            // 日期转换
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            // 开始日期选择器 确定
            onConfirmStart(date) {
                console.log(date);
                var afterTime = this.formatDate(date);
                console.log("转换后年月日==", afterTime);
                this.startDate = afterTime;
                console.log("this.startDate", this.startDate);
                this.showPickerStart = false;
            },
            // 结束日期选择器 确定
            onConfirmEnd(date) {
                console.log(date);
                var afterTime = this.formatDate(date);
                console.log("转换后年月日==", afterTime);
                this.endDate = afterTime;
                console.log("this.endDate", this.endDate);
                this.showPickerEnd = false;
            },
            // 查询
            onSubmit(values) {
                console.log('submit', values);

            }
        }
    }
</script>

<style scoped>
    /*单个选项*/
    .van-radio--horizontal {
        padding: 0.05rem;
    }
</style>